var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 10.1858C16.7248 10.1858 16.9417 10.1027 17.107 9.93749L24.152 2.89245V33.0506C24.152 33.5192 24.5309 33.8981 24.9995 33.8981C25.4682 33.8981 25.847 33.5192 25.847 33.0506V2.89245L32.8573 9.90274C33.1886 10.2341 33.7242 10.2341 34.0556 9.90274C34.387 9.57138 34.387 9.03578 34.0556 8.70442L25.5995 0.248342C25.5216 0.169527 25.4275 0.107661 25.3224 0.0644401C25.1156 -0.0211545 24.8826 -0.0211545 24.6749 0.0644401C24.5707 0.107661 24.4766 0.170374 24.3987 0.248342L15.9087 8.73916C15.5773 9.07053 15.5773 9.60613 15.9087 9.93749C16.0739 10.1036 16.2909 10.1858 16.5078 10.1858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9317 13.5587C30.463 13.5587 30.0842 13.9375 30.0842 14.4062C30.0842 14.8748 30.463 15.2536 30.9317 15.2536H41.9488V48.305H8.04992V15.2536H19.0671C19.5357 15.2536 19.9145 14.8748 19.9145 14.4062C19.9145 13.9375 19.5357 13.5587 19.0671 13.5587H6.35498V50H43.6437V13.5587H30.9317Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_1164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.df9090b64fe902fcf67a47fd233af873.svg";
export { ForwardRef as ReactComponent };